module.exports = __webpack_public_path__ + "static/media/lamina12act3.7420d99c.png";